import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import CVDocument from "@/components/CVDocument";
import { Button } from "@/components/ui/button";
import { Printer, Loader2 } from "lucide-react";

export default function CVPrint() {
  const { id } = useParams();
  const [cv, setCv] = useState(null);

  useEffect(() => { api.get(`/cvs/${id}`).then((r) => setCv(r.data)); }, [id]);

  if (!cv) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-primary" /></div>;

  return (
    <div className="min-h-screen bg-neutral-200 py-8">
      <div className="max-w-[210mm] mx-auto mb-4 flex justify-end no-print px-4">
        <Button className="rounded-full" onClick={() => window.print()} data-testid="do-print-btn"><Printer className="h-4 w-4 mr-2" /> Skriv ut / spara som PDF</Button>
      </div>
      <div className="a4-page print-page shadow-lg">
        <CVDocument cv={cv} template={cv.template} />
      </div>
    </div>
  );
}
